import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConvexReactClient } from "convex/react";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import App from "./app/App";
import "./styles/app.css";

const root = createRoot(document.getElementById("root")!);
const convexUrl = import.meta.env.VITE_CONVEX_URL as string | undefined;

root.render(
  <StrictMode>
    {convexUrl ? (
      <ConvexAuthProvider client={new ConvexReactClient(convexUrl)}>
        <BrowserRouter><App /></BrowserRouter>
      </ConvexAuthProvider>
    ) : <MissingConfiguration />}
  </StrictMode>,
);

function MissingConfiguration() {
  return <main className="configuration-screen"><div className="brand-mark" aria-hidden="true"><span /></div><p className="eyebrow">Personal Operations</p><h1>Connect the private backend.</h1><p>Add <code>VITE_CONVEX_URL</code> to <code>.env.local</code>, then build again. No application data is stored in this frontend.</p></main>;
}
